import { render, staticRenderFns } from "./VListSubItem.vue?vue&type=template&id=27ca6a4d&"
import script from "./VListSubItem.vue?vue&type=script&lang=js&"
export * from "./VListSubItem.vue?vue&type=script&lang=js&"
import style0 from "./VListSubItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VListSubItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBadge,VIcon,VListItem,VListItemTitle})
